import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { COLOR, FONT_SIZE } from 'constants/design-system';

import type { ComponentProps } from 'react';
import type { ExtractStrict } from 'util/types/strict-extract';

export type CombinedIcons = ComponentProps<typeof MaterialIcons> &
  ComponentProps<typeof MaterialCommunityIcons>;

export type MaterialCommunityIconName = ComponentProps<
  typeof MaterialCommunityIcons
>['name'];

export type MaterialIconName = ComponentProps<typeof MaterialIcons>['name'];

export type BaseIconVariant = 'material' | 'material-community';

export type BaseIconProps = Pick<CombinedIcons, 'style' | 'color' | 'size'> &
  (
    | {
        variant: ExtractStrict<BaseIconVariant, 'material-community'>;
        name: MaterialCommunityIconName;
      }
    | {
        variant: ExtractStrict<BaseIconVariant, 'material'>;
        name: MaterialIconName;
      }
  );

export const BaseIcon = (props: BaseIconProps) => {
  const { variant = 'material-community', name, style, color, size } = props;

  const Element = (() => {
    switch (variant) {
      case 'material':
        return MaterialIcons;
      case 'material-community':
      default:
        return MaterialCommunityIcons;
    }
  })();

  return (
    <Element
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      name={name as any}
      style={style}
      color={color}
      size={size ?? FONT_SIZE.theme.base}
    />
  );
};
